let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1SyR8")).then(() => parcelRequire('bSuEb'));